// tslint:disable
/// <reference path="../custom.d.ts" />
/**
 * Reposit API
 * The Reposit API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';

import { ClaimItemDocumentDTO } from '../models';
import { CreateClaimItemDocumentByDocumentIdDTO } from '../models';
/**
 * ClaimItemDocumentsApi - axios parameter creator
 * @export
 */
export const ClaimItemDocumentsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Attach a Document to a Claim Item
         * @param {string} claimId Claim id
         * @param {string} claimItemId Claim Item id
         * @param {any} file 
         * @param {string} name 
         * @param {string} type 
         * @param {string} claimItemProposalId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addClaimItemDocument(claimId: string, claimItemId: string, file: any, name: string, type: string, claimItemProposalId: string, options: any = {}): RequestArgs {
            // verify required parameter 'claimId' is not null or undefined
            if (claimId === null || claimId === undefined) {
                throw new RequiredError('claimId','Required parameter claimId was null or undefined when calling addClaimItemDocument.');
            }
            // verify required parameter 'claimItemId' is not null or undefined
            if (claimItemId === null || claimItemId === undefined) {
                throw new RequiredError('claimItemId','Required parameter claimItemId was null or undefined when calling addClaimItemDocument.');
            }
            // verify required parameter 'file' is not null or undefined
            if (file === null || file === undefined) {
                throw new RequiredError('file','Required parameter file was null or undefined when calling addClaimItemDocument.');
            }
            // verify required parameter 'name' is not null or undefined
            if (name === null || name === undefined) {
                throw new RequiredError('name','Required parameter name was null or undefined when calling addClaimItemDocument.');
            }
            // verify required parameter 'type' is not null or undefined
            if (type === null || type === undefined) {
                throw new RequiredError('type','Required parameter type was null or undefined when calling addClaimItemDocument.');
            }
            // verify required parameter 'claimItemProposalId' is not null or undefined
            if (claimItemProposalId === null || claimItemProposalId === undefined) {
                throw new RequiredError('claimItemProposalId','Required parameter claimItemProposalId was null or undefined when calling addClaimItemDocument.');
            }
            const localVarPath = `/v2/claims/{claimId}/items/{claimItemId}/documents`
                .replace(`{${"claimId"}}`, encodeURIComponent(String(claimId)))
                .replace(`{${"claimItemId"}}`, encodeURIComponent(String(claimItemId)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new FormData();


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
            if (name !== undefined) { 
                localVarFormParams.append('name', name as any);
            }
    
            if (type !== undefined) { 
                localVarFormParams.append('type', type as any);
            }
    
            if (claimItemProposalId !== undefined) { 
                localVarFormParams.append('claimItemProposalId', claimItemProposalId as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Attach a Document to a Claim Item by passing a document id
         * @param {string} claimId Claim id
         * @param {string} claimItemId Claim Item id
         * @param {CreateClaimItemDocumentByDocumentIdDTO} createClaimItemDocumentByDocumentIdDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addClaimItemDocumentByDocumentId(claimId: string, claimItemId: string, createClaimItemDocumentByDocumentIdDTO: CreateClaimItemDocumentByDocumentIdDTO, options: any = {}): RequestArgs {
            // verify required parameter 'claimId' is not null or undefined
            if (claimId === null || claimId === undefined) {
                throw new RequiredError('claimId','Required parameter claimId was null or undefined when calling addClaimItemDocumentByDocumentId.');
            }
            // verify required parameter 'claimItemId' is not null or undefined
            if (claimItemId === null || claimItemId === undefined) {
                throw new RequiredError('claimItemId','Required parameter claimItemId was null or undefined when calling addClaimItemDocumentByDocumentId.');
            }
            // verify required parameter 'createClaimItemDocumentByDocumentIdDTO' is not null or undefined
            if (createClaimItemDocumentByDocumentIdDTO === null || createClaimItemDocumentByDocumentIdDTO === undefined) {
                throw new RequiredError('createClaimItemDocumentByDocumentIdDTO','Required parameter createClaimItemDocumentByDocumentIdDTO was null or undefined when calling addClaimItemDocumentByDocumentId.');
            }
            const localVarPath = `/v2/claims/{claimId}/items/{claimItemId}/documents/by-document-id`
                .replace(`{${"claimId"}}`, encodeURIComponent(String(claimId)))
                .replace(`{${"claimItemId"}}`, encodeURIComponent(String(claimItemId)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (<any>"CreateClaimItemDocumentByDocumentIdDTO" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(createClaimItemDocumentByDocumentIdDTO !== undefined ? createClaimItemDocumentByDocumentIdDTO : {}) : (createClaimItemDocumentByDocumentIdDTO || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete Claim Item Document by id
         * @param {string} claimItemId Claim Item id
         * @param {string} claimId Claim id
         * @param {string} documentId Claim Item Document id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteClaimItemDocument(claimItemId: string, claimId: string, documentId: string, options: any = {}): RequestArgs {
            // verify required parameter 'claimItemId' is not null or undefined
            if (claimItemId === null || claimItemId === undefined) {
                throw new RequiredError('claimItemId','Required parameter claimItemId was null or undefined when calling deleteClaimItemDocument.');
            }
            // verify required parameter 'claimId' is not null or undefined
            if (claimId === null || claimId === undefined) {
                throw new RequiredError('claimId','Required parameter claimId was null or undefined when calling deleteClaimItemDocument.');
            }
            // verify required parameter 'documentId' is not null or undefined
            if (documentId === null || documentId === undefined) {
                throw new RequiredError('documentId','Required parameter documentId was null or undefined when calling deleteClaimItemDocument.');
            }
            const localVarPath = `/v2/claims/{claimId}/items/{claimItemId}/documents/{documentId}`
                .replace(`{${"claimItemId"}}`, encodeURIComponent(String(claimItemId)))
                .replace(`{${"claimId"}}`, encodeURIComponent(String(claimId)))
                .replace(`{${"documentId"}}`, encodeURIComponent(String(documentId)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a Claim Item Document by id
         * @param {string} claimId Claim id
         * @param {string} claimItemId Claim Item id
         * @param {string} documentId Claim Item Document id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findClaimItemDocumentById(claimId: string, claimItemId: string, documentId: string, options: any = {}): RequestArgs {
            // verify required parameter 'claimId' is not null or undefined
            if (claimId === null || claimId === undefined) {
                throw new RequiredError('claimId','Required parameter claimId was null or undefined when calling findClaimItemDocumentById.');
            }
            // verify required parameter 'claimItemId' is not null or undefined
            if (claimItemId === null || claimItemId === undefined) {
                throw new RequiredError('claimItemId','Required parameter claimItemId was null or undefined when calling findClaimItemDocumentById.');
            }
            // verify required parameter 'documentId' is not null or undefined
            if (documentId === null || documentId === undefined) {
                throw new RequiredError('documentId','Required parameter documentId was null or undefined when calling findClaimItemDocumentById.');
            }
            const localVarPath = `/v2/claims/{claimId}/items/{claimItemId}/documents/{documentId}`
                .replace(`{${"claimId"}}`, encodeURIComponent(String(claimId)))
                .replace(`{${"claimItemId"}}`, encodeURIComponent(String(claimItemId)))
                .replace(`{${"documentId"}}`, encodeURIComponent(String(documentId)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all Claim Item Documents by for a Claim Item by id
         * @param {string} claimItemId Claim Item id
         * @param {string} claimId Claim id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findManyClaimItemDocuments(claimItemId: string, claimId: string, options: any = {}): RequestArgs {
            // verify required parameter 'claimItemId' is not null or undefined
            if (claimItemId === null || claimItemId === undefined) {
                throw new RequiredError('claimItemId','Required parameter claimItemId was null or undefined when calling findManyClaimItemDocuments.');
            }
            // verify required parameter 'claimId' is not null or undefined
            if (claimId === null || claimId === undefined) {
                throw new RequiredError('claimId','Required parameter claimId was null or undefined when calling findManyClaimItemDocuments.');
            }
            const localVarPath = `/v2/claims/{claimId}/items/{claimItemId}/documents`
                .replace(`{${"claimItemId"}}`, encodeURIComponent(String(claimItemId)))
                .replace(`{${"claimId"}}`, encodeURIComponent(String(claimId)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ClaimItemDocumentsApi - functional programming interface
 * @export
 */
export const ClaimItemDocumentsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Attach a Document to a Claim Item
         * @param {string} claimId Claim id
         * @param {string} claimItemId Claim Item id
         * @param {any} file 
         * @param {string} name 
         * @param {string} type 
         * @param {string} claimItemProposalId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addClaimItemDocument(claimId: string, claimItemId: string, file: any, name: string, type: string, claimItemProposalId: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClaimItemDocumentDTO> {
            const localVarAxiosArgs = ClaimItemDocumentsApiAxiosParamCreator(configuration).addClaimItemDocument(claimId, claimItemId, file, name, type, claimItemProposalId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Attach a Document to a Claim Item by passing a document id
         * @param {string} claimId Claim id
         * @param {string} claimItemId Claim Item id
         * @param {CreateClaimItemDocumentByDocumentIdDTO} createClaimItemDocumentByDocumentIdDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addClaimItemDocumentByDocumentId(claimId: string, claimItemId: string, createClaimItemDocumentByDocumentIdDTO: CreateClaimItemDocumentByDocumentIdDTO, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClaimItemDocumentDTO> {
            const localVarAxiosArgs = ClaimItemDocumentsApiAxiosParamCreator(configuration).addClaimItemDocumentByDocumentId(claimId, claimItemId, createClaimItemDocumentByDocumentIdDTO, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Delete Claim Item Document by id
         * @param {string} claimItemId Claim Item id
         * @param {string} claimId Claim id
         * @param {string} documentId Claim Item Document id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteClaimItemDocument(claimItemId: string, claimId: string, documentId: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClaimItemDocumentDTO> {
            const localVarAxiosArgs = ClaimItemDocumentsApiAxiosParamCreator(configuration).deleteClaimItemDocument(claimItemId, claimId, documentId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Get a Claim Item Document by id
         * @param {string} claimId Claim id
         * @param {string} claimItemId Claim Item id
         * @param {string} documentId Claim Item Document id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findClaimItemDocumentById(claimId: string, claimItemId: string, documentId: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClaimItemDocumentDTO> {
            const localVarAxiosArgs = ClaimItemDocumentsApiAxiosParamCreator(configuration).findClaimItemDocumentById(claimId, claimItemId, documentId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Get all Claim Item Documents by for a Claim Item by id
         * @param {string} claimItemId Claim Item id
         * @param {string} claimId Claim id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findManyClaimItemDocuments(claimItemId: string, claimId: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ClaimItemDocumentDTO>> {
            const localVarAxiosArgs = ClaimItemDocumentsApiAxiosParamCreator(configuration).findManyClaimItemDocuments(claimItemId, claimId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ClaimItemDocumentsApi - factory interface
 * @export
 */
export const ClaimItemDocumentsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * Attach a Document to a Claim Item
         * @param {string} claimId Claim id
         * @param {string} claimItemId Claim Item id
         * @param {any} file 
         * @param {string} name 
         * @param {string} type 
         * @param {string} claimItemProposalId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addClaimItemDocument(claimId: string, claimItemId: string, file: any, name: string, type: string, claimItemProposalId: string, options?: any) {
            return ClaimItemDocumentsApiFp(configuration).addClaimItemDocument(claimId, claimItemId, file, name, type, claimItemProposalId, options)(axios, basePath);
        },
        /**
         * Attach a Document to a Claim Item by passing a document id
         * @param {string} claimId Claim id
         * @param {string} claimItemId Claim Item id
         * @param {CreateClaimItemDocumentByDocumentIdDTO} createClaimItemDocumentByDocumentIdDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addClaimItemDocumentByDocumentId(claimId: string, claimItemId: string, createClaimItemDocumentByDocumentIdDTO: CreateClaimItemDocumentByDocumentIdDTO, options?: any) {
            return ClaimItemDocumentsApiFp(configuration).addClaimItemDocumentByDocumentId(claimId, claimItemId, createClaimItemDocumentByDocumentIdDTO, options)(axios, basePath);
        },
        /**
         * Delete Claim Item Document by id
         * @param {string} claimItemId Claim Item id
         * @param {string} claimId Claim id
         * @param {string} documentId Claim Item Document id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteClaimItemDocument(claimItemId: string, claimId: string, documentId: string, options?: any) {
            return ClaimItemDocumentsApiFp(configuration).deleteClaimItemDocument(claimItemId, claimId, documentId, options)(axios, basePath);
        },
        /**
         * Get a Claim Item Document by id
         * @param {string} claimId Claim id
         * @param {string} claimItemId Claim Item id
         * @param {string} documentId Claim Item Document id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findClaimItemDocumentById(claimId: string, claimItemId: string, documentId: string, options?: any) {
            return ClaimItemDocumentsApiFp(configuration).findClaimItemDocumentById(claimId, claimItemId, documentId, options)(axios, basePath);
        },
        /**
         * Get all Claim Item Documents by for a Claim Item by id
         * @param {string} claimItemId Claim Item id
         * @param {string} claimId Claim id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findManyClaimItemDocuments(claimItemId: string, claimId: string, options?: any) {
            return ClaimItemDocumentsApiFp(configuration).findManyClaimItemDocuments(claimItemId, claimId, options)(axios, basePath);
        },
    };
};

/**
 * ClaimItemDocumentsApi - interface
 * @export
 * @interface ClaimItemDocumentsApi
 */
export interface ClaimItemDocumentsApiInterface {
    /**
     * Attach a Document to a Claim Item
     * @param {string} claimId Claim id
     * @param {string} claimItemId Claim Item id
     * @param {any} file 
     * @param {string} name 
     * @param {string} type 
     * @param {string} claimItemProposalId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimItemDocumentsApiInterface
     */
    addClaimItemDocument(claimId: string, claimItemId: string, file: any, name: string, type: string, claimItemProposalId: string, options?: any): AxiosPromise<ClaimItemDocumentDTO>;

    /**
     * Attach a Document to a Claim Item by passing a document id
     * @param {string} claimId Claim id
     * @param {string} claimItemId Claim Item id
     * @param {CreateClaimItemDocumentByDocumentIdDTO} createClaimItemDocumentByDocumentIdDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimItemDocumentsApiInterface
     */
    addClaimItemDocumentByDocumentId(claimId: string, claimItemId: string, createClaimItemDocumentByDocumentIdDTO: CreateClaimItemDocumentByDocumentIdDTO, options?: any): AxiosPromise<ClaimItemDocumentDTO>;

    /**
     * Delete Claim Item Document by id
     * @param {string} claimItemId Claim Item id
     * @param {string} claimId Claim id
     * @param {string} documentId Claim Item Document id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimItemDocumentsApiInterface
     */
    deleteClaimItemDocument(claimItemId: string, claimId: string, documentId: string, options?: any): AxiosPromise<ClaimItemDocumentDTO>;

    /**
     * Get a Claim Item Document by id
     * @param {string} claimId Claim id
     * @param {string} claimItemId Claim Item id
     * @param {string} documentId Claim Item Document id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimItemDocumentsApiInterface
     */
    findClaimItemDocumentById(claimId: string, claimItemId: string, documentId: string, options?: any): AxiosPromise<ClaimItemDocumentDTO>;

    /**
     * Get all Claim Item Documents by for a Claim Item by id
     * @param {string} claimItemId Claim Item id
     * @param {string} claimId Claim id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimItemDocumentsApiInterface
     */
    findManyClaimItemDocuments(claimItemId: string, claimId: string, options?: any): AxiosPromise<Array<ClaimItemDocumentDTO>>;

}

/**
 * ClaimItemDocumentsApi - object-oriented interface
 * @export
 * @class ClaimItemDocumentsApi
 * @extends {BaseAPI}
 */
export class ClaimItemDocumentsApi extends BaseAPI implements ClaimItemDocumentsApiInterface {
    /**
     * Attach a Document to a Claim Item
     * @param {string} claimId Claim id
     * @param {string} claimItemId Claim Item id
     * @param {any} file 
     * @param {string} name 
     * @param {string} type 
     * @param {string} claimItemProposalId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimItemDocumentsApi
     */
    public addClaimItemDocument(claimId: string, claimItemId: string, file: any, name: string, type: string, claimItemProposalId: string, options?: any) {
        return ClaimItemDocumentsApiFp(this.configuration).addClaimItemDocument(claimId, claimItemId, file, name, type, claimItemProposalId, options)(this.axios, this.basePath);
    }

    /**
     * Attach a Document to a Claim Item by passing a document id
     * @param {string} claimId Claim id
     * @param {string} claimItemId Claim Item id
     * @param {CreateClaimItemDocumentByDocumentIdDTO} createClaimItemDocumentByDocumentIdDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimItemDocumentsApi
     */
    public addClaimItemDocumentByDocumentId(claimId: string, claimItemId: string, createClaimItemDocumentByDocumentIdDTO: CreateClaimItemDocumentByDocumentIdDTO, options?: any) {
        return ClaimItemDocumentsApiFp(this.configuration).addClaimItemDocumentByDocumentId(claimId, claimItemId, createClaimItemDocumentByDocumentIdDTO, options)(this.axios, this.basePath);
    }

    /**
     * Delete Claim Item Document by id
     * @param {string} claimItemId Claim Item id
     * @param {string} claimId Claim id
     * @param {string} documentId Claim Item Document id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimItemDocumentsApi
     */
    public deleteClaimItemDocument(claimItemId: string, claimId: string, documentId: string, options?: any) {
        return ClaimItemDocumentsApiFp(this.configuration).deleteClaimItemDocument(claimItemId, claimId, documentId, options)(this.axios, this.basePath);
    }

    /**
     * Get a Claim Item Document by id
     * @param {string} claimId Claim id
     * @param {string} claimItemId Claim Item id
     * @param {string} documentId Claim Item Document id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimItemDocumentsApi
     */
    public findClaimItemDocumentById(claimId: string, claimItemId: string, documentId: string, options?: any) {
        return ClaimItemDocumentsApiFp(this.configuration).findClaimItemDocumentById(claimId, claimItemId, documentId, options)(this.axios, this.basePath);
    }

    /**
     * Get all Claim Item Documents by for a Claim Item by id
     * @param {string} claimItemId Claim Item id
     * @param {string} claimId Claim id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimItemDocumentsApi
     */
    public findManyClaimItemDocuments(claimItemId: string, claimId: string, options?: any) {
        return ClaimItemDocumentsApiFp(this.configuration).findManyClaimItemDocuments(claimItemId, claimId, options)(this.axios, this.basePath);
    }

}

/**
 * Standalone tree-shakeable functions for ClaimItemDocumentsApi
 * Import individual functions for optimal bundle size
 */
/**
 * Attach a Document to a Claim Item
 * @param {string} claimId Claim id
 * @param {string} claimItemId Claim Item id
 * @param {any} file 
 * @param {string} name 
 * @param {string} type 
 * @param {string} claimItemProposalId 
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function addClaimItemDocument(
    claimId: string,
    claimItemId: string,
    file: any,
    name: string,
    type: string,
    claimItemProposalId: string,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<ClaimItemDocumentDTO> {
    const localVarAxiosArgs = ClaimItemDocumentsApiAxiosParamCreator(configuration).addClaimItemDocument(claimId, claimItemId, file, name, type, claimItemProposalId, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Attach a Document to a Claim Item by passing a document id
 * @param {string} claimId Claim id
 * @param {string} claimItemId Claim Item id
 * @param {CreateClaimItemDocumentByDocumentIdDTO} createClaimItemDocumentByDocumentIdDTO 
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function addClaimItemDocumentByDocumentId(
    claimId: string,
    claimItemId: string,
    createClaimItemDocumentByDocumentIdDTO: CreateClaimItemDocumentByDocumentIdDTO,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<ClaimItemDocumentDTO> {
    const localVarAxiosArgs = ClaimItemDocumentsApiAxiosParamCreator(configuration).addClaimItemDocumentByDocumentId(claimId, claimItemId, createClaimItemDocumentByDocumentIdDTO, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Delete Claim Item Document by id
 * @param {string} claimItemId Claim Item id
 * @param {string} claimId Claim id
 * @param {string} documentId Claim Item Document id
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function deleteClaimItemDocument(
    claimItemId: string,
    claimId: string,
    documentId: string,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<ClaimItemDocumentDTO> {
    const localVarAxiosArgs = ClaimItemDocumentsApiAxiosParamCreator(configuration).deleteClaimItemDocument(claimItemId, claimId, documentId, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Get a Claim Item Document by id
 * @param {string} claimId Claim id
 * @param {string} claimItemId Claim Item id
 * @param {string} documentId Claim Item Document id
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function findClaimItemDocumentById(
    claimId: string,
    claimItemId: string,
    documentId: string,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<ClaimItemDocumentDTO> {
    const localVarAxiosArgs = ClaimItemDocumentsApiAxiosParamCreator(configuration).findClaimItemDocumentById(claimId, claimItemId, documentId, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Get all Claim Item Documents by for a Claim Item by id
 * @param {string} claimItemId Claim Item id
 * @param {string} claimId Claim id
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function findManyClaimItemDocuments(
    claimItemId: string,
    claimId: string,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<Array<ClaimItemDocumentDTO>> {
    const localVarAxiosArgs = ClaimItemDocumentsApiAxiosParamCreator(configuration).findManyClaimItemDocuments(claimItemId, claimId, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

